<template>
  <div class="OurService" style="align-self: center;">
    <!-- 黑头 -->
    <div class="header flex-all-center">
        <p>{{ $t("ourServicesAi.title") }}</p>
    </div>
    <div class="main">
      <div class="maincontent">
      <!-- 医疗AI助理 -->
          <div class="textlayout">
            <!-- 这里是文字 -->
            <div class="text">
              <div class="flex-all-center titletext">
              <p>{{ $t("ourServicesAi.text1") }}</p>
              </div>

              <p class="textcontent-en" v-if="isEn">{{ $t("ourServicesAi.text2") }}</p>
              <p class="textcontent-cn" v-else>{{ $t("ourServicesAi.text2") }}</p>

              <div class="flex-row list-item-content">

                <div class="list-item-en1" v-if="isEn">{{ $t("ourServicesAi.text3") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text3") }}</div>

                <div class="list-item-en1" v-if="isEn">{{ $t("ourServicesAi.text4") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text4") }}</div>

                <div class="list-item-en1" v-if="isEn">{{ $t("ourServicesAi.text5") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text5") }}</div>

                <div class="list-item-en1" v-if="isEn">{{ $t("ourServicesAi.text6") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text6") }}</div>

              </div>
            </div>
            <img class="imgr" src="../../assets/images/OurServiceAI_pic1.png"/>
          </div>

        <!-- 律师AI助理 -->
        <div class="textlayout">
          <img class="imgl" src="../../assets/images/OurServiceAI_pic2.png"/>
          <!-- 这里是文字 -->
          <div  class="text">
            <div class="flex-all-center ">
              <p class="titletext">{{ $t("ourServicesAi.text7") }}</p>
            </div>

            <p class="textcontent-en" v-if="isEn">{{ $t("ourServicesAi.text8") }}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServicesAi.text8") }}</p>

              <div class="flex-row list-item-content">

                  <div class="list-item-en2" v-if="isEn">{{ $t("ourServicesAi.text9") }}</div>
                  <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text9") }}</div>

                  <div class="list-item-en2" v-if="isEn">{{ $t("ourServicesAi.text10") }}</div>
                  <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text10") }}</div>

                  <div class="list-item-en2" v-if="isEn">{{ $t("ourServicesAi.text11") }}</div>
                  <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text11") }}</div>

                  <div class="list-item-en2" v-if="isEn">{{ $t("ourServicesAi.text12") }}</div>
                  <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text12") }}</div>
              </div>
          </div>
        </div>

        <!-- 元宇宙与体育 -->
        <div class="textlayout">
          <!-- 这里是文字 -->
          <div class="text">
            <div class="flex-all-center">
              <p class="titletext">{{ $t("ourServicesAi.text13") }}</p>
            </div>

            <p class="textcontent-en" v-if="isEn">{{ $t("ourServicesAi.text14") }}</p>
            <p class="textcontent-cn" v-else>{{ $t("ourServicesAi.text14") }}</p>

            
              <div class="flex-row list-item-content">

                <div class="list-item-en3" v-if="isEn">{{ $t("ourServicesAi.text15") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text15") }}</div>

                <div class="list-item-en3" v-if="isEn">{{ $t("ourServicesAi.text16") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text16") }}</div>

                <div class="list-item-en3" v-if="isEn">{{ $t("ourServicesAi.text17") }}</div>
                <div class="list-item-cn"  v-else>{{ $t("ourServicesAi.text17") }}</div>

              </div>
          </div>
          <img class="imgr" src="../../assets/images/OurServiceAI_pic3.png"/>
        </div>

      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>

import { mapState } from "vuex";
export default {
  name: "OurServiceAI",
  computed: {
    ...mapState({
      isEn: (state) => state.isEn,
    }),
  },
  data() {
    return {
    };
  },
  created() {

  },
  beforeDestroy()
  {

  },
  mounted(){

  },
  methods: {
  },
};
</script>


<style lang="scss" scoped>
.OurService{
  color: #000;
  width: 100%;
  .header{
    width: 100%;
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;

    p{
    text-align: center;
    }
  }
  .main{
    display: flex;
    justify-content: center;
    .maincontent{
      max-width: 1200px;
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 17px;
      width: 100%;
      .textlayout{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 80px;
        .text{
          width: 600px;
          align-items: center;
        }
        p{
          margin-top: 17px;
        }

        .titletext{
          font-family: "OPPO-B";
          font-size: 22px;
          color: #000;
        }

        .textcontent-cn{
          text-indent: 34px;
          text-align:justify;

        }
        .textcontent-en{
        text-indent: 34px;
        text-align: justify;
        }

        .list-item-content{
          gap: 1px;
          width: 100%;
          .list-item-cn {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 12px;
            padding-bottom: 11px;
            padding-left: 12px;
            font-family: "OPPO-B";
            font-size: 16px;
            color: #000;
            margin-top: 23px;
            height:60px;
            width: 100%;
            text-align: center;
          }

          .list-item-en1 {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 12px;
            padding-bottom: 11px;
            padding-left: 12px;
            font-family: "OPPO-B";
            font-size: 16px;
            color: #000;
            margin-top: 23px;
            width: 100%;
            height:120px;
            text-align: center;
          }

          .list-item-en2 {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 12px;
            padding-bottom: 11px;
            padding-left: 12px;
            font-family: "OPPO-B";
            font-size: 16px;
            color: #000;
            margin-top: 23px;
            width: 100%;
            height:150px;
            text-align: center;
          }

          .list-item-en3 {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 12px;
            padding-bottom: 11px;
            padding-left: 12px;
            font-family: "OPPO-B";
            font-size: 16px;
            color: #000;
            margin-top: 23px;
            width: 100%;
            height:100px;
            text-align: center;
          }
        }
      }
      .imgr{
      width: 600px;
      height: auto;
      margin-top: 0px;
      padding-left: 50px;
      }

      .imgl{
      margin-top: 0px;
      width: 600px;
      height: auto;
      padding-right: 50px;
      }
    }
  }
  .footer
  {
    margin-top: 120px;
  }
}


@media (max-width: 768px) {
.OurService{
  color: #000;
  width: 100%;
  .header{
    width: 100%;
    height: 400px;
    background: #000;
    font-family: "OPPO-L";
    font-size: 42px;
    color: #fff;

    p{
    text-align: center;
    }
  }
  .main{
    display: flex;
    justify-content: center;

    .maincontent{
      max-width: 1200px;
      color: #606266;
      font-family: "OPPO-R";
      font-size: 17px;
      line-height: 27px;
      margin-top: 17px;
      width: 90%;

      .textlayout{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        margin-top: 40px;

        .text{
          width: 100%;
          align-items: center;
        }
        p{
          margin-top: 17px;
        }

        .titletext{
          font-family: "OPPO-B";
          font-size: 22px;
          color: #000;
        }

        .textcontent-cn{
          text-indent: 34px;
          text-align:justify;

        }
        .textcontent-en{
        text-indent: 34px;
        text-align: justify;
        }

        .list-item-content{
          gap: 1px;
          width: 100%;
          justify-content: space-between;

          .list-item-cn {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 12px;
            padding-bottom: 11px;
            padding-left: 12px;
            font-family: "OPPO-B";
            font-size: 16px;
            color: #000;
            margin-top: 23px;
            height:90px;
            width: 100%;
            text-align: center;
          }

          .list-item-en1 {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 0px;
            padding-bottom: 11px;
            padding-left: 0px;
            font-family: "OPPO-B";
            font-size: 14px;
            color: #000;
            margin-top: 23px;
            width: 100%;
            height:130px;
            text-align: center;
          }

          .list-item-en2 {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 0px;
            padding-bottom: 11px;
            padding-left: 0px;
            font-family: "OPPO-B";
            font-size: 14px;
            color: #000;
            margin-top: 23px;
            width: 100%;
            height:150px;
            text-align: center;
          }

          .list-item-en3 {
            border: 2px solid #000;
            padding-top: 14px;
            padding-right: 0px;
            padding-bottom: 11px;
            padding-left: 0px;
            font-family: "OPPO-B";
            font-size: 14px;
            color: #000;
            margin-top: 23px;
            width: 100%;
            height:140px;
            text-align: center;
          }
        }
      }
      .imgr{
      width: 90%;
      height: auto;
      margin-top: 40px;
      padding-left: 0px;
      }

      .imgl{
      margin-top: 0px;
      width: 90%;
      height: auto;
      padding-right: 0px;
      }
    }
  }
  .footer
  {
    margin-top: 40px;
  }
}

}
</style>
